import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../api";
import {
  ROLE_CREATE, ROLE_CREATE_SUCCESS, ROLE_CREATE_FAIL,
  ROLE_LIST, ROLE_LIST_SUCCESS, ROLE_LIST_FAIL,
  ROLE_UPDATE, ROLE_UPDATE_SUCCESS, ROLE_UPDATE_FAIL,
  ROLE_DELETE, ROLE_DELETE_SUCCESS, ROLE_DELETE_FAIL,
} from "../../actions/admin/AdminActions";

function* roleCreate(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const response = yield call(API.roleCreate, payload);
    yield put({ type: ROLE_CREATE_SUCCESS, payload: response.data });
    if (typeof onSuccess === "function") onSuccess();
  } catch (error) {
    yield put({ type: ROLE_CREATE_FAIL, payload: { error } });
  }
}

function* roleList(action) {
  try {
    const response = yield call(API.roleList, action.payload);
    yield put({ type: ROLE_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: ROLE_LIST_FAIL, payload: { error } });
  }
}

function* roleUpdate(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const response = yield call(API.roleUpdate, payload);
    yield put({ type: ROLE_UPDATE_SUCCESS, payload: response.data });
    if (typeof onSuccess === "function") onSuccess();
  } catch (error) {
    yield put({ type: ROLE_UPDATE_FAIL, payload: { error } });
  }
}

function* roleDelete(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const response = yield call(API.roleDelete, payload);
    yield put({ type: ROLE_DELETE_SUCCESS, payload: response.data });
    if (typeof onSuccess === "function") onSuccess();
  } catch (error) {
    yield put({ type: ROLE_DELETE_FAIL, payload: { error } });
  }
}

function* roleSaga() {
  yield takeLatest(ROLE_CREATE, roleCreate);
  yield takeLatest(ROLE_LIST, roleList);
  yield takeLatest(ROLE_UPDATE, roleUpdate);
  yield takeLatest(ROLE_DELETE, roleDelete);
}

export default roleSaga;
